import Tab from '../components/Tab';
import SortBar from '../components/SortArea/SortBar';

function ReviewListPage() {
  return (
    <div>
      <SortBar name="정렬" />
      <Tab />
    </div>
  );
}

export default ReviewListPage;
